document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-gallery-thumb]');
  if (thumbnail) {
    const gallery = thumbnail.closest('.nova-product__media');
    const featured = gallery?.querySelector('[data-gallery-featured]');
    const image = featured?.querySelector('img');
    if (!featured || !image) return;

    event.preventDefault();
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = thumbnail.dataset.previewSrc;
    image.alt = thumbnail.dataset.imageAlt;
    image.width = Number(thumbnail.dataset.imageWidth);
    image.height = Number(thumbnail.dataset.imageHeight);
    featured.href = thumbnail.href;
    featured.setAttribute('aria-label', `View larger image: ${thumbnail.dataset.imageAlt}`);
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
    });
    return;
  }

  const featured = event.target.closest('[data-gallery-featured]');
  if (featured) {
    const dialog = featured.closest('.nova-product__media')?.querySelector('[data-gallery-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    event.preventDefault();
    const image = dialog.querySelector('img');
    image.src = featured.href;
    image.alt = featured.querySelector('img')?.alt || '';
    dialog.showModal();
    return;
  }

  const close = event.target.closest('[data-gallery-close]');
  if (close) close.closest('dialog')?.close();

  const dialog = event.target.closest('[data-gallery-dialog]');
  if (dialog && event.target === dialog) dialog.close();
});
